<template>
  <v-card
    v-if="showCookieBanner"
    elevation="10"
    class="cookie-notice"
  >
    <v-card-text>
      {{ $t('Сайт использует cookie. Продолжая пользоваться сайтом, вы даёте согласие на использование cookie.') + ' ' }}
      <a
        v-if="cookiePolicyFileId"
        target="_blank"
        :href="getCookieFileUrl()"
      >{{ $t('Узнать подробнее') }}</a>
      <span v-else>{{ $t('Узнать подробнее') }}</span>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn
        color="primary"
        density="comfortable"
        variant="elevated"
        @click="acceptCookies"
      >{{ $t('Понятно') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Config from "@/config";

export default {
  name: "CookieDialog",
  setup() {
    const cookiePolicyFileId = Config.getConfig('COOKIE_POLICY')?.value;
    return {cookiePolicyFileId};
  },
  data() {
    return {
      showCookieBanner: true,
    };
  },
  mounted() {
    if (localStorage.getItem('cookieConsent')) {
      this.showCookieBanner = false;
    }
  },
  methods: {
    acceptCookies() {
      this.showCookieBanner = false;
      localStorage.setItem('cookieConsent', 'true');
    },
    getCookieFileUrl() {
      return '/admin/configs/file/' + this.cookiePolicyFileId;
    }
  },
  unmounted() {
    localStorage.setItem('cookieConsent', 'false');
  }
};
</script>

<style scoped>
.cookie-notice {
  position: fixed;
  bottom: 100px;
  right: 100px;
  width: 400px;
  background-color: rgb(var(--white-color));
  z-index: 1000;
}

.cookie-notice .v-card-text {
  padding: 16px;
}

.cookie-notice .v-card-actions {
  padding: 8px 16px;
}
</style>